import { render, staticRenderFns } from "./Somos1V2RegionalIndicators2Page.vue?vue&type=template&id=f708e3c8&scoped=true"
import script from "./Somos1V2RegionalIndicators2Page.ts?vue&type=script&lang=ts&external"
export * from "./Somos1V2RegionalIndicators2Page.ts?vue&type=script&lang=ts&external"
import style0 from "./Somos1V2RegionalIndicators2Page.vue?vue&type=style&index=0&id=f708e3c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f708e3c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f708e3c8')) {
      api.createRecord('f708e3c8', component.options)
    } else {
      api.reload('f708e3c8', component.options)
    }
    module.hot.accept("./Somos1V2RegionalIndicators2Page.vue?vue&type=template&id=f708e3c8&scoped=true", function () {
      api.rerender('f708e3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1V2/page/Somos1V2RegionalIndicators2Page/Somos1V2RegionalIndicators2Page.vue"
export default component.exports